import { IPullRequestFileContext, IPullRequestContext } from "VC/Pullrequest/Common/PullRequestAdornmentService";

export interface IPullRequestAdornmentContext {
    pullRequestContext: IPullRequestContext;
    pullRequestFileContext: IPullRequestFileContext;
    isDirectory: boolean
}